var F = "-‐-―−ー－", u = "／/", a = "．.", c = "  ­​⁠　", S = "()（）［］\\[\\]", r = "~⁓∼～", A = "".concat(F).concat(u).concat(a).concat(c).concat(S).concat(r);
export {
  A as VALID_PUNCTUATION,
  c as WHITESPACE
};
//# sourceMappingURL=constants31.mjs.map
